import styled from "styled-components";

import { md3CardRadius } from "../../shared/styles/md3Components";
import { fontSizes } from "../../shared/styles/typography";

const BreadcrumbContainer = styled.nav`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.8rem 1.6rem;
  background: ${({ theme }) =>
    theme.isDarkMode
      ? `color-mix(in srgb, ${theme.colors.surface} 85%, transparent)`
      : `color-mix(in srgb, ${theme.colors.card} 88%, transparent)`};
  backdrop-filter: blur(10px);
  border-radius: ${({ theme }) => md3CardRadius(theme)}px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  width: fit-content;
  margin-bottom: 2rem;
  transition: background 0.25s ease, border-color 0.25s ease,
    box-shadow 0.25s ease;

  &:hover {
    background: ${({ theme }) =>
      theme.isDarkMode ? theme.colors.surfaceSecondary : theme.colors.card};
    border-color: ${({ theme }) =>
      `color-mix(in srgb, ${theme.colors.primary} 35%, transparent)`};
    box-shadow: ${({ theme }) => theme.shadows.md3Level1};
  }

  .breadcrumb-item {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    font-size: ${fontSizes.sm}px;
    font-weight: ${({ theme }) => theme.fontWeight.semibold};
    color: ${({ theme }) => theme.colors.textSecondary};
    transition: color 0.2s ease;

    a {
      color: inherit;
      text-decoration: none;

      &:hover {
        color: ${({ theme }) => theme.colors.primary};
      }
    }

    &.active {
      color: ${({ theme }) => theme.colors.primary};
    }

    &.tag {
      background: ${({ theme }) =>
        `color-mix(in srgb, ${theme.colors.primary} 12%, transparent)`};
      color: ${({ theme }) => theme.colors.primary};
      padding: 0.2rem 0.8rem;
      border-radius: ${({ theme }) => theme.layout.radiusSm};
      font-weight: ${({ theme }) => theme.fontWeight.semibold};
    }
  }

  .separator {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.textTertiary};
  }
`;

export default BreadcrumbContainer;
